var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{attrs:{"shadow":"never"}},_vm._l((this.defaultList),function(item,index){return _c('div',{key:index,staticClass:"detail_item"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(item.label)+"：")]),_c('span',{staticClass:"value no-wrap"},[_vm._v(_vm._s(_vm.detail[item.key]))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }